import { memo } from "react";
import { cn } from "@/lib/utils";

const ROWS = [
  { hasThirdLine: true, bodyWidth: "w-[90%]" },
  { hasThirdLine: false, bodyWidth: "w-[65%]" },
  { hasThirdLine: true, bodyWidth: "w-[80%]" },
  { hasThirdLine: false, bodyWidth: "w-[55%]" },
  { hasThirdLine: true, bodyWidth: "w-[72%]" },
] as const;

export const MessageListSkeleton = memo(function MessageListSkeleton() {
  return (
    <div aria-hidden className="flex flex-col gap-5 px-1 py-4">
      {ROWS.map((row, i) => (
        <div key={i} className="flex gap-3 items-start">
          <div className="h-8 w-8 rounded-md bg-foreground/[0.05] animate-pulse shrink-0" />
          <div className="flex-1 space-y-2">
            <div className="h-3 w-24 rounded bg-foreground/[0.05] animate-pulse" />
            <div
              className={cn(
                "h-3 max-w-xl rounded bg-foreground/[0.04] animate-pulse",
                row.bodyWidth,
              )}
            />
            {row.hasThirdLine && (
              <div className="h-3 w-[45%] max-w-md rounded bg-foreground/[0.04] animate-pulse" />
            )}
          </div>
        </div>
      ))}
    </div>
  );
});
